<script lang="ts">
    import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
    import ClientAutocomplete from '@/components/account/modals/newOrderRequest/ClientAutocomplete.vue'

    @Component({mixins: [ClientAutocomplete]})
    export class PersonSelectAutocomplete extends Vue {
        cancelTokenSources = []
        @Prop() role

        async loadClients() {
            try {
                this.cancelTokenSources.forEach(cancelTokenSource => cancelTokenSource.cancel())
                this.cancelTokenSources = []
                this.isLoadingClients = true

                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                const newItems = (
                    await this.$api.persons.get(
                        {
                            pattern: this.searchInput,
                            ...(this.companyId && {companyId: this.companyId}),
                            limit: this.limit,
                        },
                        cancelTokenSource.token
                    )
                ).users
                    .filter(u => (this.role ? u.role.includes(this.role) : true))
                    .sort((a, b) => a.lastName?.localeCompare(b.lastName))

                // vuetify workaround cache items
                if (this.itemValue && this.multiple) {
                    this.clients = [
                        ...new Map([...this.clients, ...newItems].map(item => [item['personId'], item])).values(),
                    ]
                } else {
                    this.clients = newItems
                }
            } catch (e) {
                /* empty */
            } finally {
                this.isLoadingClients = false
            }
        }

        inputText(val) {
            if (!val) return ''
            const {firstName, firstNameLocalized, lastName, lastNameLocalized, prefix} = val
            const fullName = [prefix, firstName || firstNameLocalized, lastName || lastNameLocalized].filter(Boolean)
            return fullName.join(' ')
        }
    }

    export default {...toNative(PersonSelectAutocomplete), ssrRender: ClientAutocomplete.ssrRender}
</script>
